import { render } from "./gradeitem.vue?vue&type=template&id=70dfe026&scoped=true"
import script from "./gradeitem.vue?vue&type=script&lang=js"
export * from "./gradeitem.vue?vue&type=script&lang=js"

import "./gradeitem.vue?vue&type=style&index=0&id=70dfe026&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70dfe026"]])

export default __exports__